import * as React from 'react';
import type { SVGProps } from 'react';
const SvgConvertSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#454655"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 5.833H6.86c-1.176 0-1.764 0-2.213.223-.396.196-.717.51-.918.895C3.5 7.389 3.5 7.962 3.5 9.109v5.041c0 .954 0 1.431.16 1.807.213.502.622.9 1.136 1.108.386.156.876.156 1.854.156m7.56 8.445h6.93c1.176 0 1.764 0 2.213-.223.395-.196.717-.51.918-.895.229-.437.229-1.01.229-2.157v-6.756c0-1.147 0-1.72-.229-2.158a2.07 2.07 0 0 0-.918-.895c-.449-.223-1.037-.223-2.213-.223h-6.93c-1.176 0-1.764 0-2.213.223-.396.196-.717.51-.918.895-.229.438-.229 1.01-.229 2.157v6.757c0 1.146 0 1.72.229 2.158.201.385.522.698.918.894.449.223 1.037.223 2.213.223M10.5 5.834h7.583m0 0L14 2.334m4.083 3.5L14 9.334"
    />
  </svg>
);
export default SvgConvertSide;
